import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
// import About from "./pages/About";
// import Contact from "./pages/Contact";
import Login from "./pages/Login";
import CustomNavbar from "./components/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import BillingTable from "./pages/BillingTable";
import UpdateCustomerData from "./pages/UpdateCustomerData";
import UserTable from "./pages/UserDetails";
import OrderTable from "./pages/OrderHistory";
import CategoryTable from "./pages/Categories";
import NewOrderPage from "./pages/NewOrderPage";
import EditOrder from "./pages/EditOrder";
const App = () => {
  return (
    <Router>
      <AuthProvider>
        <CustomNavbar />
        <div className="container mt-4">
          <Routes>
            <Route path="/" element={<NewOrderPage />} />
            <Route path="/admin_access" element={<BillingTable />} />
            <Route path="/order_log" element={<OrderTable/>} />
            <Route path="/editorder/:id" element={<EditOrder/>} />
            <Route path="/categories" element={<CategoryTable/>} />
            <Route path="/customer_data" element={<UpdateCustomerData />} />
            <Route path="/login" element={<Login />} />
            <Route path="/user" element={<UserTable />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
};

export default App;
